module.exports = __webpack_public_path__ + "img/motortimelogo.1b8f1a53.png";